import umuWebview from '@umu/umu-webview';
import { ShareObjType, EAppShareType as ShareType } from '@umu/umu-types';

type ICallback = ([...args]: any) => void;

export interface IAppShareOption {
    id: string; // 分享对象id
    obj_type: string | ShareType; // ShareType

    shareUrl?: string; // 分享链接
    shareIcon?: string;
    shareTitle?: string;
    shareDesc?: string;

    g_title?: string;
    s_type?: string; // session type
    s_title?: string; // session title
    shareQrUrl?: string; // 分享二维码地址
    acCode?: string;
    type_name?: string;
    // 分享到班级相关
    share_id?: string;
    shareToClass?: number; // 是否可以分享到班级，0 | 1
    shareTargetType?: ShareObjType; // 班级分享类型

    shareCardView?: string; // 分享页 url
}

/**
 * 当用户点击app的share按钮时，触发jsCallback
 * shareOption 传给app的参数
 * jsCallback 回调函数
 * data app返回的回调参数
 */
function onAppShareClick(jsCallback: ICallback | null, shareOption?: IAppShareOption) {
    umuWebview.registerHandler('appCallShare', (data: any, callback?: ICallback) => {
        if (jsCallback) {
            jsCallback(data);
        }
        if (callback) {
            callback(shareOption || {});
        }
    });
}

/**
 * app分享图片时，如排行榜，勋章，把当前需要分享图片url传给app
 */
function shareImgForApp(url: string, jsCallback?: ICallback) {
    const shareImgOption = {
        id: '', // 分享对象id
        obj_type: 'image', // 分享对象类别Image
        shareUrl: url,
    };

    const shareOption = shareImgOption;
    umuWebview.registerHandler('appCallShare', (data: any, callback?: ICallback) => {
        if (callback) {
            callback(shareOption);
        }
        if (jsCallback) {
            jsCallback(data);
        }
    });
}

export { onAppShareClick, shareImgForApp };
